import auth from 'src/router/middleware/authentification/auth.js'

const Users = () => import('src/views/Management/Users/Users.vue')

export default [
  {
    path: '/users',
    component: Users,
    name: 'users',
    meta: {
      layout: 'sdui',
      isPublic: false,
      middleware: [auth],
      group: 'users',
      transitionPoint: 1,
      headerText: 'global.headers.user_management',
      iconUsers: 'icon-user-settings'
    }
  }
]
